import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';
import { AppLogo } from '../../shared/components';
import backgroundImage from '../assets/login-bg.png';

export default function AuthLayout() {
  return (
    <Stack direction='row' sx={{ height: '100vh', position: 'fixed', inset: 0 }}>
      <Stack
        direction='column'
        sx={{
          width: '50vw',
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          gap: '10vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Outlet />
      </Stack>
      <Stack
        direction='column'
        sx={{
          width: '50vw',
          paddingTop: '20vh',
          backgroundColor: 'background.default',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom center',
          transition: 'background-image 0.5s ease-in-out',
        }}
      >
        <AppLogo showTagline size='lg' orientation='vertical' />
      </Stack>
    </Stack>
  );
}
